import React from 'react';

import { Center, Stack, Text } from '@good/ui/core';

import { BookingCardPopover } from '../bookings-roster-view/roster-weekly/components/booking-card-popover';
import { IRosterBooking, IRosterShift } from '../bookings-roster-view/types';
import { BookingDrawerContentType } from './types';
import { AssignedShiftPopover } from '../bookings-roster-view/roster-weekly/components/assigned-shift-popover';
import { OpenSlotPopover } from '../bookings-roster-view/roster-weekly/components/open-slot-popover';
import { ROSTER_TAB } from '../bookings-roster-view/components/roster-common-enums';
import CustomerBookingPopover from '../bookings-roster-view/roster-daily/components/CustomerBookingPopover';
import OpenShiftPopover from '../bookings-roster-view/roster-daily/components/OpenShiftPopover';
import WorkerShiftPopover from '../bookings-roster-view/roster-daily/components/WorkerShiftPopover';
import { GroupOf3People } from '@good/illustrations';

interface BookingDrawerContentProps {
  selectedRosterItem: IRosterBooking | IRosterShift | null;
  type: BookingDrawerContentType | null;
  setCanCloseDrawer: (canClose: boolean) => void;
  refreshAndCloseData: () => void;
  rosterTab: ROSTER_TAB | null;
}

export const BookingDrawerContent = ({
  selectedRosterItem,
  type,
  setCanCloseDrawer,
  rosterTab,
  refreshAndCloseData,
}: BookingDrawerContentProps) => {
  if (!selectedRosterItem || !type || !rosterTab) {
    return (
      <Center p='md'>
        <Stack align='center'>
          <GroupOf3People size='md' />
          <Text fw={550}>No booking or shift selected from calendar</Text>
        </Stack>
      </Center>
    );
  }

  if (rosterTab === ROSTER_TAB.DAILY) {
    switch (type) {
      case 'customerBooking':
        return (
          <CustomerBookingPopover
            booking={selectedRosterItem as IRosterBooking}
            setCanClosePopover={setCanCloseDrawer}
            refreshAndCloseData={refreshAndCloseData}
          />
        );
      case 'workerShift':
        return (
          <WorkerShiftPopover
            shift={selectedRosterItem as IRosterShift}
            setCanClosePopover={setCanCloseDrawer}
            refreshAndCloseData={refreshAndCloseData}
          />
        );
      case 'openSlot':
        return <OpenShiftPopover shift={selectedRosterItem as IRosterShift} />;
    }
  }

  switch (type) {
    case 'customerBooking':
      return (
        <BookingCardPopover
          booking={selectedRosterItem as IRosterBooking}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
    case 'workerShift':
      return (
        <AssignedShiftPopover
          shift={selectedRosterItem as IRosterShift}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
    case 'openSlot':
      return (
        <OpenSlotPopover
          shift={selectedRosterItem as IRosterShift}
          setCanClosePopover={setCanCloseDrawer}
          refreshAndCloseData={refreshAndCloseData}
        />
      );
  }
};
